import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import Sidebar from '../../modules/sidebar/sidebar';
import { accountCompany } from '../../store/selectors/company-info';
import { RootState } from '../../types';

const SidebarContainer: React.FC = () => {
  const location = useLocation();
  const profile = useSelector((state: RootState) => state.auth.profile);
  const companyInfo = useSelector(accountCompany);

  const accountName = () => {
    if (profile.firstName && profile.lastName)
      return `${profile.lastName} ${profile.firstName}`;
    return undefined;
  };

  return (
    <Sidebar
      accountName={accountName()}
      accountRole={profile.role}
      pathname={location.pathname}
      companyName={companyInfo?.shortName}
      companyPhoto={profile.logoLink}
    />
  );
};

export default SidebarContainer;
